import { useCallback, useEffect, useState } from "react";
import {
  listSurfActivityJobs,
  type SurfActivityJob,
} from "@vida/surf-core";
import { createSurfApiConfig, ensureSurfClientConfig } from "../services/surfClientConfig";

const POLL_MS = 12_000;

export function useSurfActivityFeed(enabled = true) {
  const [jobs, setJobs] = useState<SurfActivityJob[]>([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const refresh = useCallback(async () => {
    if (!enabled) return;
    setLoading(true);
    try {
      await ensureSurfClientConfig();
      const cfg = createSurfApiConfig();
      const result = await listSurfActivityJobs(cfg, { limit: 25 });
      setJobs(result.items);
      setError(null);
    } catch (e) {
      setError(e instanceof Error ? e.message : String(e));
    } finally {
      setLoading(false);
    }
  }, [enabled]);

  useEffect(() => {
    void refresh();
    if (!enabled) return;
    const id = window.setInterval(() => void refresh(), POLL_MS);
    return () => window.clearInterval(id);
  }, [enabled, refresh]);

  return { jobs, loading, error, refresh };
}
